// hooks/useDeleteEmployee.ts
import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../../environment";

const DELETE_EMPLOYEE_URL = `${API_BASE_PATH}/register/admin/delete`;

// ====== Error Extractor ======
const extractErrorMessage = (error: any) => {
  const detail = error?.response?.data?.detail;
  let details = error?.response?.data?.details;
  const message = error?.response?.data?.message;

  if (typeof details === "string") {
    details = details.replace(/^\d+\s*:\s*/, ""); // strip numeric codes
  }

  return detail || details || message;
};

const useDeleteEmployee = () => {
  const deleteEmployee = async (employeeId: string, _token?: string | null) => {
    try {
      const token = localStorage.getItem("authToken");
      await axios.delete(`${DELETE_EMPLOYEE_URL}/${employeeId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Employee deleted successfully");
    } catch (err: any) {
      console.error("Error deleting employee:", err);
      toast.error(extractErrorMessage(err));
      throw err;
    }
  };

  return { deleteEmployee };
};

export default useDeleteEmployee;
